import SearchPrimary2020 from '@svg/survey/where/search_primary_20_20.svg';
import SpinnerLoader1818 from '@svg/common/spinner_loader_18_18.svg';
import { TRIP_MODE, TripModeType } from '@/app/ui/trip/client-trip-page';
import { TRIP_CONDITIONS } from '@/app/ui/trip/client-trip-page';

interface TripMapViewProps {
  SearchHelperChipsComponent: React.ReactNode;
  SearchRetryButtonComponent: React.ReactNode;
  isEditRole: boolean;
  mode: TripModeType;
  editUser: string | null;
  onClickChangeMode: (nextMode: TripModeType) => Promise<void>;
  children: React.ReactNode;
}

export default function TripMapView({
  SearchHelperChipsComponent,
  SearchRetryButtonComponent,
  isEditRole,
  mode,
  editUser,
  onClickChangeMode,
  children,
}: TripMapViewProps) {
  return (
    <div
      id='planner-map'
      className='relative w-full bg-gray-200'
      style={{
        height: 'calc(100dvh - 56px)',
      }}
    >
      {SearchHelperChipsComponent}
      {SearchRetryButtonComponent}
      {TRIP_CONDITIONS.IS_VIEW_MODE(mode) && isEditRole && !editUser && (
        <div className='absolute z-10 w-full max-w-[480px] px-20pxr top-16pxr h-44pxr'>
          <button
            className='flex items-center w-full bg-gray-100 pl-14pxr pr-16pxr py-12pxr gap-8pxr rounded-6pxr h-44pxr shadow-clear'
            onClick={async () => {
              onClickChangeMode(TRIP_MODE.SEARCH);
            }}
            style={{ boxShadow: '4px 4px 10px 0px rgba(0, 0, 0, 0.10)' }}
          >
            <span className='p-2pxr'>
              <SearchPrimary2020 className='flex-none' />
            </span>
            <p className='text-gray-500 body-14-regular'>여행지 검색하기</p>
          </button>
        </div>
      )}
      {TRIP_CONDITIONS.IS_VIEW_MODE(mode) && isEditRole && editUser && (
        <div className='absolute z-10 w-full max-w-[480px] px-20pxr top-16pxr h-44pxr'>
          <div
            className='flex items-center justify-center w-full h-full border px-12pxr py-9pxr rounded-4pxr border-primary bg-[#EAF1FF] text-primary sub-heading-14-m gap-6pxr'
            style={{
              boxShadow: '0px 0px 4px 0px rgba(136, 136, 136, 0.80)',
            }}
          >
            <SpinnerLoader1818 className='animate-spin' />
            <p>지금 {editUser}님이 편집 중이에요.</p>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
